import { useRef } from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";

export const ParallaxSection = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });

  // Increased stiffness but kept other values for slow movement
  const springConfig = {
    mass: 3.5, // Increased mass for slower overall movement
    stiffness: 45, // Much higher stiffness for quick direction changes
    damping: 55, // Higher damping for slower overall movement
    restDelta: 0.0001,
  };

  const smoothProgress = useSpring(scrollYProgress, springConfig);

  // Reduced movement range for slower perceived motion
  const firstLineX = useTransform(
    smoothProgress,
    [0, 0.2, 0.5, 0.8, 1],
    ["0%", "-3%", "-7%", "-12%", "-15%"], // Smaller total range
  );

  const secondLineX = useTransform(
    smoothProgress,
    [0, 0.2, 0.5, 0.8, 1],
    ["-15%", "-12%", "-7%", "-3%", "0%"], // Smaller total range
  );

  const repeatedText = "The sky is the limit. ".repeat(8);

  return (
    <div ref={containerRef} className="relative w-full overflow-x-hidden py-20">
      {/* First line - Right to Left */}
      <div className="relative w-full">
        <div className="whitespace-nowrap">
          <motion.div
            initial={{ x: "0%" }}
            style={{ x: firstLineX }}
            className="inline-block text-5xl font-bold text-red-400"
          >
            {repeatedText}
            {repeatedText}
          </motion.div>
        </div>
      </div>

      {/* Second line - Left to Right */}
      <div className="relative mt-8 w-full">
        <div className="whitespace-nowrap">
          <motion.div
            initial={{ x: "-15%" }}
            style={{ x: secondLineX }}
            className="inline-block text-5xl font-bold text-red-400"
          >
            {repeatedText}
            {repeatedText}
          </motion.div>
        </div>
      </div>
    </div>
  );
};
